<template>
  <va-create-layout>
    <irrigations-form :title="title" :item="item"></irrigations-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ['title', 'item'],
}
</script>
